export default __webpack_public_path__ + "static/media/partner_mobile_ico.180daef7.webp";